exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-form {\r\n    min-width: 150px;\r\n    max-width: 65em;\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-full-width {\r\n    width: 100%;\r\n  }\r\n  \r\n  .example-large-width {\r\n    width: 10em;\r\n  }\r\n  \r\n  .example-date-width {\r\n    max-width: 8em;\r\n  }\r\n  \r\n  .example-margin {\r\n    margin: 0 0px;\r\n  }\r\n  \r\n  .example-card1-width {\r\n    max-width: 40em;\r\n    margin: 0 auto;\r\n  }\r\n  \r\n  \r\n  \r\n  .example-hide {\r\n    display: none;\r\n  }\r\n  \r\n  .search-result{\r\n    border-bottom: 1px solid gray;\r\n    border-left: 1px solid gray;\r\n    border-right: 1px solid gray;\r\n    width:195px;\r\n    height: 16px;\r\n    padding: 5px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n  }\r\n   \r\n  .search-result:hover {\r\n    color: #eee;\r\n    background-color: #607D8B;\r\n  }\r\n   \r\n  #search-box{\r\n    width: 200px;\r\n    height: 20px;\r\n  }\r\n  \r\n  .select-small {\r\n    max-width: 7em;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Dev/Angular/liceo/src/app/case-master/case-master.component.css
// module id = ../../../../../src/app/case-master/case-master.component.css
// module chunks = main